import React, { useEffect, useState } from 'react';
import BulletChart from 'components/BulletChart/BulletChart';
import { Row, Select } from 'antd';
import LineChart from 'components/LineChart/LineChart';
import TableResultControlTask from 'components/TableResultControlTask/TableResultControlTask';
import { TResultAssignmentForOneStudent } from 'types/assignments';
import { DATA_SELECT, DATA_TYPE_CALCULATED_ANSWER, DATA_TYPE_STUDENT_ANSWER } from 'constants/common';
import { aliasValue } from 'constants/date';
import './style.css';
import { TChartDataAll } from 'types/results';
import { convertCorrectData, convertData, convertRangeData } from 'libs/helpers/functions';
import { configLineChart } from 'components/LineChart/lineChartConfig';
import { configBulletChart } from './AssignmentsResultCultivateAdm.state';
import styles from './style.module.scss';

type Props = {
  resultAssignment: TResultAssignmentForOneStudent;
  isShowLoading: boolean;
  dataCalculateInit: any;
  dataCorrectInit: any;
};
const DEFAULT_SELECT_VALUE = 'C1';
const AssignmentsResultCultivateAdm = ({
  resultAssignment,
  isShowLoading,
  dataCalculateInit,
  dataCorrectInit,
}: Props) => {
  const [selectValue, setSelectValue] = useState(DEFAULT_SELECT_VALUE);
  const [dataChart, setDataChart] = useState<TChartDataAll>({
    maxData: [],
    dataLine: [],
    minData: [],
  });
  useEffect(() => {
    if (!isShowLoading) {
      setDataChart({
        maxData: [],
        dataLine: [...dataCalculateInit, ...dataCorrectInit],
        minData: [],
      });
    }
  }, [isShowLoading, dataCorrectInit]);
  const handleChange = (als: string) => {
    setSelectValue(als);
    if (als === aliasValue.C1 || als === aliasValue.C2 || als === aliasValue.C3) {
      const dataCalculate = convertData(
        resultAssignment.controlResult?.studentAnswers,
        als,
        false,
        DATA_TYPE_CALCULATED_ANSWER,
      );
      const dataCorrect = convertCorrectData(resultAssignment.controlResult?.correctAnswers ?? [], als);
      setDataChart({
        minData: [],
        maxData: [],
        dataLine: [...dataCalculate, ...dataCorrect],
      });
    } else {
      const dataMinValue = convertRangeData(resultAssignment.controlResult?.correctAnswers ?? [], als, 'min');
      const dataMaxValue = convertRangeData(resultAssignment.controlResult?.correctAnswers ?? [], als, 'max');
      const dataCorrect = convertCorrectData(resultAssignment.controlResult?.correctAnswers ?? [], als);
      const dataStudentAnswer = convertData(
        resultAssignment.controlResult?.studentAnswers,
        als,
        false,
        DATA_TYPE_STUDENT_ANSWER,
      );
      setDataChart({
        dataLine: [...dataCorrect, ...dataStudentAnswer],
        minData: dataMinValue,
        maxData: dataMaxValue,
      });
    }
  };
  return (
    <>
      <p className={styles.bodySection}>採点結果</p>
      <hr />
      <TableResultControlTask
        maxScore={resultAssignment.maxScore}
        morningScore={resultAssignment.controlResult?.morningScore}
        afternoonScore={resultAssignment.controlResult?.afternoonScore}
        beforeNightScore={resultAssignment.controlResult?.beforeNightScore}
        midnightScore={resultAssignment.controlResult?.midnightScore}
      />
      <p className={styles.bodySection}>回答解説</p>
      <hr />
      <div>
        <BulletChart
          configChart={configBulletChart(resultAssignment.controlResult?.morningScore, '   早朝時間帯    ').configScore}
        />
        <BulletChart
          configChart={
            configBulletChart(resultAssignment.controlResult?.afternoonScore, '   日中時間帯    ').configScore
          }
        />
        <BulletChart
          configChart={
            configBulletChart(resultAssignment.controlResult?.beforeNightScore, '前夜半時間帯    ').configScore
          }
        />
        <BulletChart
          configChart={configBulletChart(resultAssignment.controlResult?.midnightScore, '  夜間時間帯    ').configScore}
        />
      </div>
      <Row className={styles.progressControlWrapper}>
        <p>環境センサー</p>
        <Select
          defaultValue={DEFAULT_SELECT_VALUE}
          onChange={handleChange}
          options={DATA_SELECT}
          className={styles.titleSelect}
        />
      </Row>
      <LineChart alias={selectValue} configChart={configLineChart(dataChart)} />
    </>
  );
};

export default AssignmentsResultCultivateAdm;
